import { render, staticRenderFns } from "./_video-detail-popup.vue?vue&type=template&id=a34522ae&scoped=true&"
import script from "./_video-detail-popup.vue?vue&type=script&lang=js&"
export * from "./_video-detail-popup.vue?vue&type=script&lang=js&"
import style0 from "./_video-detail-popup.vue?vue&type=style&index=0&id=a34522ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34522ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VChip,VCol,VRow})
